import { fetchReportingActivities, DateRangeFilter, ReportingActivity } from "./query/reportingActivitiesAPI";
import { locales } from "@/constants/constants";
import type { Locale } from "./query/reportingActivitiesAPI";
import store from '@/store';
import { getSchoolYearWithFallbacks } from '@/utilities/getSchoolYearWithFallbacks';

// Convert locale from hyphenated format (en-us) to GraphQL format (EN_US)
function convertLocaleForGraphQL(locale: string): Locale {
  const localeMap: { [key: string]: Locale } = {
    'en-us': 'EN_US',
    'EN-US': 'EN_US',
    'es-mx': 'ES_MX',
    'ES-MX': 'ES_MX',
  };
  
  return localeMap[locale] || 'EN_US'; // Default to EN_US if unknown
}

export async function getReportingActivitiesForStudent(
  studentId: string, dateRange: DateRangeFilter | null = null, equatedScores: boolean, locale: string
): Promise<Array<ReportingActivity> | null> {
  try {
    // Convert locale to GraphQL format
    const graphqlLocale = convertLocaleForGraphQL(locale);
    
    //disable equating for Spanish because it's not supported
    if (graphqlLocale === 'ES_MX') equatedScores = false;

    //dateRange defaults to the current school year if not provided
    if (!dateRange) {
      const state = store.getState();
      const assessmentCalendar = state.calendar?.assessmentCalendar;
      const schoolYearCalendar = state.calendar?.schoolYearCalendar;
      
      // Get school year dates using fallback utility
      const schoolYearResult = getSchoolYearWithFallbacks(assessmentCalendar, schoolYearCalendar);
      
      dateRange = {
        dateStart: new Date(schoolYearResult.startDate).toISOString(),
        dateEnd: new Date(schoolYearResult.endDate).toISOString(),
      };
    }

    const response = await fetchReportingActivities(studentId, dateRange, equatedScores, graphqlLocale);
    // Extract activities from the correct path
    let activities = response?.getReportingActivities || [];
    
    // Add ARM estimate to scores key (same logic as old endpoint)
    activities = activities.map(activity => {
      if (activity.scoreEstimates && activity.scores) {
        activity.scores.currentArmEstimate = activity.scoreEstimates.ARM_estimate;
      }
      return activity;
    });
    
    return activities;
  }
  catch (error) {
    console.error("Error fetching reporting activities", error);
    return null;
  }
}
